
import FormStore from '@/store/formStore';
import { Vue, Component, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';

@Component
export default class FormConsent extends Vue {
  // VUEX MODULES
  formStore: FormStore | null = null;

  // DATA
  formConsent = false;

  rules = [(v: boolean) => v || 'Prohlášení musí být zaškrtnuto.'];

  // HOOKS
  async created() {
    this.formStore = getModule(FormStore);
  }

  // WATCHERS
  @Watch('formConsent')
  watchFormConsent() {
    this.$emit('input', this.formConsent);
  }
}
